import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NodeDetailsDTO } from './env-configuration/node-details.dto';

@Injectable()
export class ThemeService {
  public static THEME_LOCAL_STORAGE_KEY = 'theme';

  themes: Theme[];

  private _themeSubj: Subject<Theme> = new Subject<Theme>();

  themeObs: Observable<Theme> = this._themeSubj.asObservable();

  private currentTheme: Theme;

  private nodeDetails: NodeDetailsDTO;

  private themesMap = {
    PROD: [
      // {class: 'orange-light-theme', name: 'Light orange'},
      // {class: 'orange-dark-theme', name: 'Dark orange'}
      { class: 'blue-light-theme', name: 'Light blue' },
      { class: 'dark-theme-1', name: 'UK' },
      { class: 'dark-theme-2', name: 'CA' },
      { class: 'dark-theme-3', name: 'CA-FR' },
      { class: 'dark-theme-4', name: 'JP' },
      { class: 'dark-theme-5', name: 'IE' },
      { class: 'dark-theme-6', name: 'AU' },
      { class: 'dark-theme-7', name: 'NZ' },
      { class: 'dark-theme-8', name: 'PL' },
      { class: 'blue-light-theme', name: 'Light blue' },
      { class: 'blue-dark-theme', name: 'Dark blue' },
    ],
    NON_PROD: [
      { class: 'blue-light-theme', name: 'Light blue' },
      { class: 'cohort-light-theme-1', name: 'UK' },
      { class: 'dark-theme-2', name: 'CA' },
      { class: 'dark-theme-3', name: 'CA-FR' },
      { class: 'dark-theme-4', name: 'JP' },
      { class: 'dark-theme-5', name: 'IE' },
      { class: 'dark-theme-6', name: 'AU' },
      { class: 'dark-theme-7', name: 'NZ' },
      { class: 'dark-theme-8', name: 'PL' },
      { class: 'blue-light-theme', name: 'Light blue' },
      { class: 'blue-dark-theme', name: 'Dark blue' },
    ],
  };

  setTheme(theme: Theme) {
    this._themeSubj.next(theme);
    this.currentTheme = theme;
    localStorage.setItem(ThemeService.THEME_LOCAL_STORAGE_KEY, theme.class);
  }

  setThemeForCohortId(cohortId: number) {
    if (localStorage.getItem(ThemeService.THEME_LOCAL_STORAGE_KEY)) {
      const themeClass = localStorage.getItem(ThemeService.THEME_LOCAL_STORAGE_KEY);
      return this.themes.find((t) => t.class === themeClass) || this.themes[0];
    }
    this.themes = this.themesMap[this.nodeDetails.operationalMode] || this.themesMap.NON_PROD;
    const theme = this.themes.find((t) => t.class === `dark-theme-${cohortId}`) || this.themes[0];
    this.setTheme(theme);
  }

  getCurrentTheme() {
    return this.currentTheme ? this.currentTheme : this.themes[0];
  }

  getThemeOnStartup() {
    const themeClass = localStorage.getItem(ThemeService.THEME_LOCAL_STORAGE_KEY);
    return this.themes.find((t) => t.class === themeClass) || this.themes[0];
  }

  initializeThemes(nodeDetails: NodeDetailsDTO) {
    this.nodeDetails = nodeDetails;
    this.themes = this.themesMap[nodeDetails.operationalMode] || this.themesMap.NON_PROD;
    // override store theme
    // this.setTheme(this.themes.find(t => t.class === 'blue-light-theme') || this.themes[0]);
  }
}

export interface Theme {
  name: string;
  class: string;
}
